import { gql } from '@apollo/client';

export const updateCheckoutHealthOfferData = gql`
  mutation updateCheckoutHealthOfferData($params: CheckoutHealthOfferDataInput!) {
    updateCheckoutHealthOfferData(params: $params)
  }
`;